import { Router } from '@angular/router';
import { Component, Input} from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { AppSettings } from './../../app.settings';
import { StorageService } from './../../services/storage.service';
import { CommonBindingDataService } from './../../../shared/services/common-binding-data.service';
import { formatDateCell } from './../../../shared/utility-functions/grid';

import { MiGridComponent } from '../../../shared/mi-grid/mi-grid.component';
import { ViewChild, OnInit } from '@angular/core';



@Component({
    selector: 'app-recent-emergency-request',
    templateUrl: './recent-emergency-request.component.html',
    standalone: false
})
export class RecentEmergencyRequestComponent implements OnInit {
  @Input() headerLHS;
  gridTheme = 'mi';
  showSerialNo = false;
  @ViewChild(MiGridComponent) gridRef: MiGridComponent;
  url = '/secure/emergency/list/data';
  gridColumn: any;
  exportUrl = '';
  printUrl = '';
  params: any = '';
  corpId;

  labelSave;
  labelCancel;


  constructor(private commonService: CommonBindingDataService,
    private router: Router,
    private storageService: StorageService
  ) {
    this.corpId = this.storageService.getItem(AppSettings.CURRENT_USER_CORPORATE_ID);
    this.gridColumn = [
      {
        headerName: this.commonService.getLabel('label_booking_ID'),
        field: 'bookingCode',
        colId: 'bookingCode',
        maxWidth: 200,
      },
      {
        headerName: this.commonService.getLabel('label_driver_name'),
        field: 'driverName',
        colId: 'driverName',
        maxWidth: 200,
      },
      {
        headerName: this.commonService.getLabel('label_current_location'),
        field: 'locationName',
        colId: 'locationName'
      },
      {
        headerName: this.commonService.getLabel('label_reason'),
        field: 'reason',
        colId: 'reason'
      },
      {
        headerName: this.commonService.getLabel('label_date_time_list'),
        cellRenderer: this.formatBookingDate,
        colId: 'createdAt'
      }
    ];

  }

  formatBookingDate(params) {
    return formatDateCell(params.data.createdAt);
  }

  ngOnInit() {

    this.params = '';
    if (this.corpId) {
      this.url = this.url + '?partnerType=Corporate&partnerId=' + this.corpId;
    } else {
      this.url = this.url + '?partnerType=&partnerId=';
    }

    this.gridRef.changeDatasource(this.url, this.gridColumn);
  }


  viewAllNotifications() {
    this.router.navigate(['emergency-request']);
  }

}
